import { POST } from "../../helper/collaticaRestFunctions";
export const createOrgRoles = async (org_id: any, data: any) => {
  const path = `/orgs/${org_id}/roles`;
  return await POST(path, data)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching users > ", err);
      return err;
    });
};
